module.exports = __webpack_public_path__ + "34bf1a59a69dd8b5ec3b04189b1be9a7.woff";